export default __webpack_public_path__ + "images/anim-edge-transparent.de19dff92d6757658df9c07c3d9aed8b.gif";